import cookieFunc from "@/libs/cookie";
import { loginWithCodeApi, getUserInfoApi, logoutApi } from "@/api/index";

import { getPersonalInfo, checkIsLogin } from "@/api/api";

import Axios from "axios";
import Router from "@/router/index";
import { Toast } from "vant";
export default {
    state: {
        token: "",
        userInfo: {},
        authUrl: "",
        tokenIsUseful: 0, //1为有用 0 无用
    },
    mutations: {
        //在登录页使用
        setToken(state, token) {
            state.token = token;
            // cookieFunc.setCookie("token", token);
            localStorage.setItem("token", token);
        },
        //在登录页使用
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
        },
        setTokenIsUseful(state, flag) {
            state.tokenIsUseful = flag;
        },
        // setAuthUrl(state, authUrl) {
        //     state.authUrl = authUrl;
        //     localStorage.setItem("wxAuthUrl", authUrl);
        // },

        //退出登录使用
        delToken(state) {
            state.token = "";
            // cookieFunc.delCookie("token");
            localStorage.removeItem("token");
        },
        //退出登录使用
        delUserInfo(state) {
            state.userInfo = {};
            localStorage.removeItem("userInfo");
        },
        //
        delAuthUrl(state) {
            state.authUrl = "";
            localStorage.removeItem("wxAuthUrl");
        },
    },
    getters: {
        userInfo: (state) => {
            return state.userInfo;
        },
        tokenIsUseful: (state) => {
            return state.tokenIsUseful

        }
    },
    actions: {
        // 登录
        handleLogin({ commit }, { phoneNo, captchaCode, code }) {
            return new Promise((resolve, reject) => {
                //500会被拦截 所以重新写
                // loginWithCodeApi({ phoneNo, captchaCode, code }).then((res) => {
                Axios.post(`/api/login`, { phoneNo, captchaCode, code }).then((res) => {
                    if (res.data.code == 200) {
                        commit("setToken", res.data.data);
                        resolve(1);
                    }
                    if (res.data.code == 500) {
                        if (res.data.data == 1) {
                            Toast("验证码无效");
                        } else if (res.data.data == null) {
                            Toast("暂无权限");
                            Router.go(0);
                        }
                    }
                });
            });
        },
        // 退出登录
        handleLogOut({ state, commit }) {
            localStorage.removeItem("token");
            localStorage.removeItem("userId");
            localStorage.removeItem("openId");
            Toast("退出登录成功");
        },
        // 获取用户相关信息
        getUserInfo({ commit }) {
            getPersonalInfo().then((res) => {
                if (res.code == 200) {
                    commit("setUserInfo", res.data);
                }
            });
        },
        checkIsLogin({
            commit
        }) {
            checkIsLogin().then(res => {
                commit('setTokenIsUseful', res.data)
            })
        }
    },
};
